import { render, staticRenderFns } from "./UserProfileMembership.vue?vue&type=template&id=044f768e&scoped=true&"
import script from "./UserProfileMembership.vue?vue&type=script&lang=js&"
export * from "./UserProfileMembership.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileMembership.vue?vue&type=style&index=0&id=044f768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f768e",
  null
  
)

export default component.exports